import { render, staticRenderFns } from "./commend.vue?vue&type=template&id=e9a1477c&scoped=true"
import script from "./commend.vue?vue&type=script&lang=js"
export * from "./commend.vue?vue&type=script&lang=js"
import style0 from "./commend.vue?vue&type=style&index=0&id=e9a1477c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a1477c",
  null
  
)

export default component.exports